const TAB_PREFIX = "grants-";
const SEARCH_PARAM = "search";
const YEAR_PARAM = "grant_year";
const AMOUNT_PARAM = "grant_amount";

export class URLManager {
  constructor() {
    this.tabPrefix = TAB_PREFIX;
    this.searchParam = SEARCH_PARAM;
    this.yearParam = YEAR_PARAM;
    this.amountParam = AMOUNT_PARAM;
  }

  /**
   * Parses the URL for tab slug (from hash), search query, year, and amount (from query params).
   * @returns {{tabSlug: string, searchTerm: string, year: string, amount: string}}
   */
  parseGrantsURL() {
    // Get search term, year, and amount from query parameters
    const params = new URLSearchParams(window.location.search);
    const searchTerm = params.get(this.searchParam) || "";
    const year = params.get(this.yearParam) || "";
    const amount = params.get(this.amountParam) || "";

    // Get tab slug from hash
    const hash = window.location.hash.replace("#", "");
    let tabSlug = "";

    if (hash === "featured-grants") {
      // Handle single tab case where hash is #featured-grants
      tabSlug = "featured-grants";
    } else if (hash.startsWith(this.tabPrefix)) {
      tabSlug = hash.replace(this.tabPrefix, "");
    }

    return { tabSlug, searchTerm, year, amount };
  }

  /**
   * Builds the URL with search, year, and amount in query params and tab in hash.
   * @param {string} tabSlug
   * @param {string} searchTerm
   * @param {string} year
   * @param {string} amount
   * @returns {{search: string, hash: string}}
   */
  buildGrantsURL(tabSlug, searchTerm, year, amount) {
    const params = new URLSearchParams(window.location.search);

    if (searchTerm) {
      params.set(this.searchParam, searchTerm);
    } else {
      params.delete(this.searchParam);
    }

    if (year) {
      params.set(this.yearParam, year);
    } else {
      params.delete(this.yearParam);
    }

    if (amount) {
      params.set(this.amountParam, amount);
    } else {
      params.delete(this.amountParam);
    }

    const search = params.toString() ? `?${params.toString()}` : "";
    // Use #featured-grants without prefix for single tab case, otherwise use grants- prefix
    const hash = tabSlug
      ? tabSlug === "featured-grants"
        ? `#${tabSlug}`
        : `#${this.tabPrefix}${tabSlug}`
      : "";

    return { search, hash };
  }

  /**
   * Updates the browser's URL with search, year, amount params and hash.
   * @param {string} tabSlug
   * @param {string} searchTerm
   * @param {string} year
   * @param {string} amount
   * @param {boolean} replaceState - If true, replaces the current history entry; otherwise, pushes a new one.
   */
  updateURL(tabSlug, searchTerm, year = "", amount = "", replaceState = false) {
    const { search, hash } = this.buildGrantsURL(
      tabSlug,
      searchTerm,
      year,
      amount,
    );
    const newURL = `${window.location.pathname}${search}${hash}`;

    if (window.location.href !== window.location.origin + newURL) {
      if (replaceState) {
        history.replaceState(null, null, newURL);
      } else {
        history.pushState(null, null, newURL);
      }
    }
  }
}
